<template>
    <v-container fluid class="pa-0 fill-height align-start">
        <transition name="page">
            <router-view />
        </transition>
    </v-container>
</template>

<script>
export default {
    name: 'EmptyRouterView'
}
</script>